import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'reactstrap';
import clearModal from '@shoflo/studio-redux/actions/modal/clearModal/clearModal';
import { PRESENTER_SETTINGS } from '@shoflo/polymer/constants/ModalTypes';
import { PresenterSettings as PresenterSettingsComponent } from '@shoflo/polymer/components/PresenterSettings/PresenterSettings';
import updatePresenterSettings from 'actions/Broadcast/presenters/updatePresenterSettings';
import { CAMERA_PRESENTER } from '@studio/constants/Sources';

const PresenterSettings = () => {
  const isOpen = useSelector(
    ({ modal }) => modal && modal.type === PRESENTER_SETTINGS
  );
  const {
    presenterSettingsSource,
    meeting: { meetingSession, attendeeTiles }
  } = useSelector(state => state);

  const dispatch = useDispatch();
  const clearThisModal = () => dispatch(clearModal(PRESENTER_SETTINGS));
  const handleFormSave = payload => {
    dispatch(updatePresenterSettings(presenterSettingsSource, payload));
    clearThisModal();
  };

  const maxWidthMap = {
    [CAMERA_PRESENTER]: '436px',
    default: '572px'
  };

  const style = {
    maxWidth: maxWidthMap[presenterSettingsSource.type] || maxWidthMap.default
  };

  if (!isOpen) return null;

  return (
    <Modal isOpen={isOpen} toggle={clearThisModal} autoFocus style={style}>
      <PresenterSettingsComponent
        source={presenterSettingsSource}
        meetingSession={meetingSession}
        attendeeTiles={attendeeTiles}
        onSubmit={handleFormSave}
        onCancel={clearThisModal}
      />
    </Modal>
  );
};

export default PresenterSettings;
